export const props = {
  // Values
  list: undefined,
  listInit: {
    type: Boolean,
    default: true
  },
  translation: {
    type: Array,
    default: ['text']
  },
  keyText: {
    type: String,
    default: 'text'
  },
  keyValue: {
    type: String,
    default: 'value'
  },
  ajax: [Function, String],
  request: Object,
  cache: Boolean,
  maxlength: Number,
  multiple: Boolean,
  underline: String,
  filter: {
    type: String,
    default: ''
  },
  modelValue: undefined,

  // Status
  selected: undefined,
  readonly: Boolean,
  disabled: Boolean,

  // Item
  itemAttrs: undefined,

  // Window
  windowWidth: { default: '240px' },
  windowAutoClose: undefined,
  windowAttrs: undefined
}
